<app-spinner-overlay
    [showSpinner]="isSearching"
>
</app-spinner-overlay>
@if(venue$ | async; as venue) {
    <app-paged-booking-list
        [venue]="venue"
        [bookings$]="bookings$"
        [config]="config"
        [isSearching]="isSearching"
        [isShowingResults]="true"
        [emptyStateTitle]="emptyStateTitle"
        [emptyStateDescription]="emptyStateDescription"
        (pageChanged)="pageChanged($event)"
        (bookingSelected)="bookingSelected.emit($event)"
    >
    </app-paged-booking-list>
}
